import { SsoCallback } from './SsoCallback'

/**
 * SSO Callback wrapper.
 * No Redux connection needed -- SsoCallback uses store.dispatch directly
 * (same pattern as Apple Sign-In callback handling).
 */
export default SsoCallback
